var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.6656C13.4723 14.6656 14.6658 13.4721 14.6658 11.9999C14.6658 10.5277 13.4723 9.33423 12.0001 9.33423C10.5279 9.33423 9.33447 10.5277 9.33447 11.9999C9.33447 13.4721 10.5279 14.6656 12.0001 14.6656Z",
    fill: "#C2C6CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5112 10.28C18.4776 8.59663 16.1265 5.77234 12 5.77234C7.87352 5.77234 5.52239 8.59663 4.48877 10.28C3.83708 11.3341 3.83708 12.666 4.48877 13.7201C5.52239 15.4035 7.87352 18.2277 12 18.2277C16.1265 18.2277 18.4776 15.4035 19.5112 13.7201C20.1629 12.666 20.1629 11.3341 19.5112 10.28ZM12 15.9985C9.79168 15.9985 8.00147 14.2083 8.00147 12C8.00147 9.79172 9.79168 8.00151 12 8.00151C14.2083 8.00151 15.9985 9.79172 15.9985 12C15.9963 14.2074 14.2074 15.9963 12 15.9985Z",
    fill: "#C2C6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c221dd0094f52ae1b336df150df92867.svg";
export { ForwardRef as ReactComponent };